import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import { ContentBlock } from "../../pages/components";
import { VideoPlayerContainer } from "./";
import colors from "../../../utils/colors";
import { formatPlainText } from "../../../utils/content-utils";
import { media } from "../../../utils/uiSizes";
import TagListArticle from "../../common/components/TagListArticle";

const StyledContent = styled.div`
  max-width: 700px;

  p {
    margin-bottom: 1rem;
    line-height: 1.5rem;

    ${media.tablet`
      line-height: 1.3125rem;
    `};
  }
`;

const StyledTitle = styled.h4`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const StyledCategory = styled.h6`
  text-transform: uppercase;
  color: ${colors.GRAY};
  margin-bottom: 1rem;
  letter-spacing: 0.109375rem;
`;

const StyledLead = styled.h3`
  text-align: center;
  font-size: ${rem("22px")};
  font-family: FyranSans-Book;
  text-align: center;
  padding: 0 0 ${rem("40px")};
  color: ${colors.GRAY_MIDDLE};
`;

const StyledFigure = styled.figure`
  width: 100%;
  margin-bottom: 2rem;

  img {
    width: 100%;
    height: auto;
  }
`;

const Article = props => {
  const { imageUrl, videoUrl, lead, title, category, content, link, tags } = props;

  return (
    <ContentBlock>
      {videoUrl ? (
        <VideoPlayerContainer videoUrl={videoUrl} />
      ) : imageUrl ? (
        <StyledFigure>
          <img src={imageUrl} alt="" />
        </StyledFigure>
      ) : null}
      <StyledContent>
        {lead && <StyledLead>{lead}</StyledLead>}
        {category && <StyledCategory>{category}</StyledCategory>}
        {title && <StyledTitle>{title}</StyledTitle>}
        <div dangerouslySetInnerHTML={{ __html: formatPlainText(content) }} />
        {link && (
          <footer>
            <a href="{link}">{link}</a>
          </footer>
        )}
        {tags && <TagListArticle tags={tags} linked />}
      </StyledContent>
    </ContentBlock>
  );
};

export default Article;



// WEBPACK FOOTER //
// ./src/modules/content/components/Article.js